<article class="container">
  <section class="otp">
    <app-search-input
      [config]="{
        placeholder: 'common.otp' | translate,
        'margin-block-end': '1em',
        icon: 'otp',
        minLength: 6,
        maxLength: 6,
        preventSpace: true
      }"
      [textControl]="this.textControl"
    ></app-search-input>
  </section>
  <section class="send-otp">
    <button
      class="button"
      [disabled]="this.isButtonClicked"
      [style.background-color]="
        !this.isButtonClicked || this.timeLeft === 0 ? '#0000bf' : '#ebf5ff'
      "
      (click)="this.emitOtpSend()"
      type="button"
    >
      {{
        !this.isButtonClicked
          ? ("common.send" | translate)
          : this.timeLeft > 0
          ? this.timeLeft
          : ("common.send" | translate)
      }}
    </button>
  </section>
</article>
